import React from 'react';
import { useIntl } from 'react-intl';
import application from 'services/application';
import Page from 'pages/layout/page';
import Shimmer from 'components/shimmer';

import messages from './online-support.i18n';

const OnlineSupport: React.FunctionComponent<unknown> = () => {
  const { formatMessage } = useIntl();
  const currentProduct = application.current;

  return (
    <Page
      title={formatMessage(messages.pages.help.onlineSupport.seo[currentProduct].title)}
      seo={{
        title: formatMessage(messages.pages.help.onlineSupport.seo[currentProduct].title),
        description: formatMessage(messages.pages.help.onlineSupport.seo[currentProduct].title),
      }}
    >
      <Shimmer loading width="100%" height={440} />
    </Page>
  );
};

export default OnlineSupport;
